<div class="contato-container">
  <!-- Header -->
  <div class="header">
    <div class="header-content">
      <h2 class="page-title">
        <i class="fa fa-address-book"></i>
        Gerenciamento de Contatos
      </h2>
    </div>
  </div>

  <!-- Filtros -->
  <div class="filtros-container">
    <div class="row align-items-end">
      <div class="col-md-8">
        <div class="form-group">
          <label for="filtroNome">Nome</label>
          <input 
            type="text" 
            id="filtroNome"
            class="form-control" 
            placeholder="Buscar por nome..."
            [(ngModel)]="filtroNome">
        </div>
      </div>
      <div class="col-md-4 d-flex justify-content-start">
        <button class="btn btn-secondary btn-limpar" (click)="limparFiltros()">
          <i class="fa fa-times"></i>
          Limpar
        </button>
      </div>
    </div>
  </div>



  <!-- Tabela de Contatos -->
  <div class="table-container">
    <div class="card">
      <div class="card-header">
        <h5>
          <i class="fa fa-list"></i>
          Lista de Contatos ({{ getContatosFiltrados().length }})
        </h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Email</th>
                <th>Mensagem</th>
                <th>Data Criação</th>
                <th>Lido</th>
                <th style="width: 100px;">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let contato of getContatosFiltrados()">
                <td>
                  <strong>{{ contato.nome }}</strong>
                </td>
                <td>{{ contato.email }}</td>
                <td>
                  <div class="mensagem-cell">
                    {{ contato.mensagem }}
                  </div>
                </td>
                <td>{{ contato.dataCriacao }}</td>
                <td>
                  <div class="toggle-switch">
                    <input 
                      type="checkbox" 
                      id="lido-{{ contato.id }}"
                      [checked]="contato.lido"
                      (change)="alterarStatusLido(contato)"
                      class="toggle-input">
                    <label 
                      for="lido-{{ contato.id }}" 
                      class="toggle-label">
                    </label>
                  </div>
                </td>
                <td>
                  <button 
                    class="btn btn-sm btn-outline-danger" 
                    (click)="excluirContato(contato.id)"
                    title="Excluir">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mensagem quando não há contatos -->
        <div *ngIf="getContatosFiltrados().length === 0" class="text-center py-4">
          <i class="fa fa-inbox fa-3x text-muted mb-3"></i>
          <p class="text-muted">
            {{ contatos.length === 0 ? 'Nenhum contato cadastrado.' : 'Nenhum contato encontrado com os filtros aplicados.' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div> 